(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cazador-product-card-purchase"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cazador-card-purchase')) {
    customElements.define(
      'cazador-card-purchase',
      class extends HTMLElement {
        connectedCallback() {
          if (this.dataset.cazadorBound === 'true') return;
          this.dataset.cazadorBound = 'true';
          this.addEventListener('change', this.handleVariantChange);
        }

        handleVariantChange = (event) => {
          const input = event.target.closest('[data-cazador-variant]');
          if (!input || !this.contains(input)) return;

          const variantIdInput = this.querySelector('[data-cazador-variant-id]');
          const price = this.querySelector('[data-cazador-selected-price]');
          const button = this.querySelector('[data-cazador-add-button]');
          const buttonText = this.querySelector('[data-cazador-add-text]');
          const available = input.dataset.available === 'true';

          if (variantIdInput) variantIdInput.value = input.value;
          if (price) price.textContent = input.dataset.price || '';
          if (button) button.disabled = !available;
          if (buttonText) buttonText.textContent = available ? 'Add to cart' : 'Sold out';
        };
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
